import { render } from "./app-icon-empty-customer.vue?vue&type=template&id=41de199f"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/icon/app-icon-empty-customer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41de199f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41de199f', __exports__)) {
    console.log('reload')
    api.reload('41de199f', __exports__)
  }
  
  module.hot.accept("./app-icon-empty-customer.vue?vue&type=template&id=41de199f", () => {
    console.log('re-render')
    api.rerender('41de199f', render)
  })

}


export default __exports__